import React from 'react';
import type { Lead } from '../types/leadScript';
const TOKEN_PATTERN = /\{(\w+)\}/g;
export function renderScriptText(text: string, lead: Lead): React.ReactNode[] {
  const fields = lead as unknown as Record<string, string>;
  return text.split(TOKEN_PATTERN).map((part, index) => {
    if (index % 2 === 0) return <React.Fragment key={index} data-id="element-50" data-mp="20niojuffdqep">{part}</React.Fragment>;
    return <span key={index} className="whitespace-nowrap rounded bg-accent px-1 py-px font-semibold text-white [box-decoration-break:clone]" data-id="element-51" data-mp="25ltxm2xwbwvv" data-mpi={index}>
        {fields[part] ?? part}
      </span>;
  });
}